export const MATCH_LIST = 'match_list'
export const TAB_LIST = 'tab_list'
export const MATCH_DETAIL = 'match_detail'
export const MATCH_LIST_WEB = 'FEATURED'